























import Vue from 'vue'
import Component from 'vue-class-component'
import ModalV2 from '@/components/modals/ModalV2.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { required } from 'vuelidate/lib/validators'

@Component({
  components: {
    InputValidator,
    InputV2,
    ModalV2
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    templateName: {
      type: String,
      default: ''
    }
  }
})
export default class AddEditTemplateModal extends Vue {
  name: string = ''

  validations (): any {
    return {
      name: {
        required
      }
    }
  }
  mounted () {
    this.name = this.$props.templateName
  }
  update (eventType: 'add' | 'edit') {
    this.$v.$touch()

    if (this.$v.$anyError) {
      return
    }

    this.$emit(eventType, this.name)
  }
  updateValue (value: string) {
    this.name = value
  }
}
